import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface AttendanceSearchParams {
  keyword?: string;
  nik?: string;
  employeeName?: string;
  attendanceStatus?: string;
  officeLocation?: string;
  attendanceDate?: string;
  range?: string;
  vendorId?: string;
  leaveType?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getAttendances = async (params: AttendanceSearchParams = {}) => {
  const response = await axiosInstance.get("/attendances/search_attendances", {
    params,
  });
  return response.data;
};


export const fetchAttendancePhotoBlob = async (filename: string): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/attendances/photo/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};



// Step 1: Create Attendance
export const createAttendance = async (data) => {
  // const formData = {
  //   attendanceName: data.officName,
  //   attendanceAddress: data.attendanceAddress,
  //   region: data.region,
  //   attendanceType: data.attendanceType,
  //   attendanceEmail: data.attendanceEmail,
  //   managerName: data.managerName,
  //   contactNumber:data.contactNumber,
  // };

  if (data.attendanceStatus === "Presence") {
    const hasCheckin = data.checkinTime !== '' && data.checkinTime !== null;
    const hasCheckout = data.checkoutTime !== '' && data.checkoutTime !== null;
    const hasOvertimeIn = data.overtimeIn !== '' && data.overtimeIn !== null;
    const hasOvertimeOut = data.overtimeOut !== '' && data.overtimeOut !== null;

    if (!hasCheckin) data.checkinTime = null; 
    if (!hasCheckout) data.checkoutTime = null; 
    if (!hasOvertimeIn) data.overtimeIn = null; 
    if (!hasOvertimeOut) data.overtimeOut = null; 

    console.log(data.attendanceStatus, hasCheckin, hasCheckout, hasOvertimeIn, hasOvertimeOut);
  
    const isValidWithoutOvertime = hasCheckin && hasCheckout && !hasOvertimeIn && !hasOvertimeOut;
    const isValidWithOvertime = hasCheckin && hasCheckout && hasOvertimeIn && hasOvertimeOut;
  
    data.attendanceStatus = (isValidWithoutOvertime || isValidWithOvertime) ? "Valid" : "Not Valid";
  }
  

  const response = await axiosInstance.post(`/attendances/create_attendance`, data);
  return response.data; // contains the attendance `id` or `code`
};

// Step 2: Upload Photo by Attendance ID
export const uploadAttendancePhoto = async (attendanceId, file, field) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/attendances/upload_photo/${attendanceId}/${field}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Edit Attendance
export const editAttendance = async (data) => {
  const formData = {
    attendanceName: data.officName,
    attendanceAddress: data.attendanceAddress,
    region: data.region,
    attendanceType: data.attendanceType,
    attendanceEmail: data.attendanceEmail,
    managerName: data.managerName,
    contactNumber: data.contactNumber,
  };

  if(data.attendanceStatus==="Presence" && data.checkinTime != '' && data.checkoutTime != '' && data.overtimeIn == '' && data.overtimeOut == ''){
    data.attendanceStatus = await "Valid";
  }

  if(data.attendanceStatus==="Presence" && data.checkinTime != '' && data.checkoutTime != '' && data.overtimeIn != '' && data.overtimeOut != ''){
    data.attendanceStatus = await "Valid";
  }

  if(data.attendanceStatus==="Presence"){
    data.attendanceStatus = await "Not Valid";
  }

  const response = await axiosInstance.put(`/attendances/update_attendance/${data.id}`, data);
  return response.data; // contains the attendance `id` or `code`
};

export const deleteAttendance = async (attendanceId: string) => {
  const response = await axiosInstance.delete(`/attendances/delete_attendance/${attendanceId}`);
  return response.data;
};
